const tableTitleAreas = {
  title: 'Departamentos',
  placeholder: 'Buscar por departamento'
}

export default tableTitleAreas;
